import _object_spread from "@swc/helpers/src/_object_spread.mjs";
import _object_spread_props from "@swc/helpers/src/_object_spread_props.mjs";
import _object_without_properties from "@swc/helpers/src/_object_without_properties.mjs";
import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import { Translation } from "@core/locales";
import { Box, Prompt, Stack, Text, factory } from "@coveord/plasma-mantine";
import { Children, isValidElement, useMemo } from "react";
import { Locales } from "../../../strings/Locales.js";
import { ProjectList } from "../ProjectsList.js";
import classes from "./DeleteSingleResourcePrompt.module.css";
import { DeleteSingleResourcePromptCancelButton } from "./DeleteSingleResourcePromptCancelButton.js";
import { DeleteSingleResourcePromptConfirmButton } from "./DeleteSingleResourcePromptConfirmButton.js";
import { DeleteSingleResourcePromptHelpers } from "./DeleteSingleResourcePromptHelpers.js";
export var DeleteSingleResourcePrompt = factory(function(_param, ref) {
    var additionalDescription = _param.additionalDescription, children = _param.children, onClose = _param.onClose, opened = _param.opened, _projects = _param.projects, projects = _projects === void 0 ? {
        isLoading: false,
        isError: false,
        data: []
    } : _projects, resourceName = _param.resourceName, resourceType = _param.resourceType, promptProps = _object_without_properties(_param, [
        "additionalDescription",
        "children",
        "onClose",
        "opened",
        "projects",
        "resourceName",
        "resourceType"
    ]);
    var _$ref;
    var _$ref1;
    var normalizedResourceName = (_$ref1 = resourceName === null || resourceName === void 0 ? void 0 : resourceName.trim()) !== null && _$ref1 !== void 0 ? _$ref1 : "";
    var _$ref2;
    var isProjectsError = (_$ref2 = projects === null || projects === void 0 ? void 0 : projects.isError) !== null && _$ref2 !== void 0 ? _$ref2 : false;
    var hasProjectState = (projects === null || projects === void 0 ? void 0 : projects.isLoading) || isProjectsError || (projects === null || projects === void 0 ? void 0 : (_$ref = projects.data) === null || _$ref === void 0 ? void 0 : _$ref.length) > 0;
    var promptButtons = useMemo(function() {
        return Children.toArray(children).filter(function(child) {
            return /*#__PURE__*/ isValidElement(child) && (child.type === DeleteSingleResourcePromptCancelButton || child.type === DeleteSingleResourcePromptConfirmButton);
        });
    }, [
        children
    ]);
    var descriptionKey = DeleteSingleResourcePromptHelpers.getSingleResourceDescription({
        hasProjectState: hasProjectState,
        isProjectsError: isProjectsError,
        resourceName: normalizedResourceName
    });
    return /*#__PURE__*/ _jsxs(Prompt, _object_spread_props(_object_spread({
        title: Locales.format("DeleteSingleResourcePrompt.title", {
            resourceType: resourceType
        }),
        variant: "critical",
        opened: opened,
        onClose: onClose,
        ref: ref
    }, promptProps), {
        children: [
            /*#__PURE__*/ _jsxs(Stack, {
                gap: "sm",
                children: [
                    /*#__PURE__*/ _jsx(Text, {
                        children: /*#__PURE__*/ _jsx(Translation, {
                            t: Locales,
                            i18nKey: descriptionKey,
                            options: {
                                resourceType: resourceType,
                                resourceName: normalizedResourceName
                            },
                            children: /*#__PURE__*/ _jsx(Text, {
                                inherit: true,
                                span: true,
                                fw: 500,
                                className: classes.root
                            })
                        })
                    }),
                    hasProjectState && projects && /*#__PURE__*/ _jsx(ProjectList, {
                        projects: projects
                    }),
                    additionalDescription && /*#__PURE__*/ _jsx(Box, {
                        "data-testid": "delete-single-resource-prompt-additional-description",
                        children: additionalDescription
                    })
                ]
            }),
            /*#__PURE__*/ _jsx(Prompt.Footer, {
                children: promptButtons
            })
        ]
    }));
});
DeleteSingleResourcePrompt.CancelButton = DeleteSingleResourcePromptCancelButton;
DeleteSingleResourcePrompt.ConfirmButton = DeleteSingleResourcePromptConfirmButton;
DeleteSingleResourcePrompt.displayName = "DeleteSingleResourcePrompt";

//# sourceMappingURL=DeleteSingleResourcePrompt.js.map